import styled, { css } from 'styled-components';

import { CONTAINER_MAX } from '@/constants/breakpoints';
import { flexColumn, flexRow } from '@/styles/common';

import { Typography } from '../ui/Typography/Typography.styles';

const modalSmall = css`
  width: 354px;
  padding: 25px;
  gap: 20px;
`;

const modalMedium = css`
  padding: 40px;
  width: 440px;
  gap: 30px;
`;

export const Wrapper = styled.div`
  ${flexColumn};
  justify-content: center;
  ${modalMedium};
  @media (max-width: ${CONTAINER_MAX.tablet}) {
    ${modalSmall}
  }
`;

export const ModalActions = styled.div`
  width: 100%;
  ${flexRow};
  align-items: center;
  gap: 10px;
`;

export const Subtitle = styled(Typography).attrs({ variant: 'body2' })`
  color: var(--textAndLabels-tertiary);
`;

export const ContentWrapper = styled.div`
  ${flexColumn};
  align-items: center;
  text-align: center;
  gap: 10px;
`;
